'use client';

import * as React from 'react';

import { type LinkLike, NativeLink } from '../../lib/link';

export interface IconLinkProps {
	/** URL di destinazione. */
	href: string;
	/** Chiamata al click, oltre alla navigazione. */
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
	/** Icona iniziale, dimensionata automaticamente. */
	icon?: React.ReactNode;
	/** Testo del link. */
	children: React.ReactNode;
	/** Componente link da usare (default: link nativo `<a>`); passare il `Link` del router quando serve navigazione client-side. */
	linkComponent?: LinkLike;
}

/** Link inline colorato ad accento, con icona iniziale opzionale. */
const IconLink = ({
	href,
	onClick,
	icon,
	children,
	linkComponent: Link = NativeLink,
}: IconLinkProps) => (
	<Link
		href={href}
		onClick={onClick}
		className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-accent transition-colors hover:text-accent/70 [&_svg]:h-3.5 [&_svg]:w-3.5"
	>
		{icon}
		{children}
	</Link>
);
IconLink.displayName = 'IconLink';

export { IconLink };
